module.exports = __webpack_public_path__ + "fonts/opensans-light-webfont.ca5d5c00.woff";